import { PLAN_STATUS } from 'Common/Constants/Constants'

/**
 * What the schedule list lets you do with a schedule in each status. One
 * place, because the row click and the row menu must agree: the menu used to
 * offer Input on a RUNNING schedule while the click handler silently ignored
 * it.
 */

/**
 * A run is in flight. `RUNNING` is what the direct-to-Rust path writes
 * (scheduler_api sets it at the start and clears it at the end); `INITIATED`
 * is the legacy Synapse path's equivalent, still honoured for old rows.
 */
export const isRunInFlight = (status?: string) =>
  status === PLAN_STATUS.RUNNING || status === PLAN_STATUS.INITIATED

/**
 * The input page can be opened. Includes RUNNING, because opening it
 * reattaches to the run's progress (`useRunSchedulerDirect`'s
 * `resumeSchedulerId`), and FAILED, so the inputs can be fixed and run again.
 */
export const canOpenInput = (status?: string) =>
  status === PLAN_STATUS.SUCCESS ||
  status === 'UNSTARTED' ||
  status === PLAN_STATUS.RUNNING ||
  status === PLAN_STATUS.FAILED

/**
 * The output page can be opened. Only after a successful run: a run writes
 * its output as it goes, so mid-run the output can mix old and new rows.
 */
export const canOpenOutput = (status?: string) => status === PLAN_STATUS.SUCCESS

/**
 * Delete and access changes are blocked while a run is in flight: deleting
 * a schedule its run is still writing to leaves the run writing into nothing.
 */
export const canModifySchedule = (status?: string) => !isRunInFlight(status)
